var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.openHint)?_c('div',{staticClass:"init_text"},[_vm._v("正在进入系统...")]):_vm._e(),_vm._v(" "),_c('iframe',{ref:"monitor",attrs:{"src":_vm.url+'/#/'+_vm.routeUrl+'?token='+_vm.token+'&openType=login'+'&username='+_vm.username,"frameborder":"0"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78746c76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = null
// module chunks = 